export const cls = {
  accessLevel: 59,
  activityArea: 24,
  addressType: 20,
  author: 203,
  authorshipType: 140,
  cities: 154,
  contentType: 57,
  countries: 208,
  educationLevel: 53,
  educationType: 52,
  genders: 46,
  identitySystem: 38,
  keywords: 107,
  lang: 2,
  position: 47,
  publicationThematic: 211,
  publicationType: 39,
  scienceArea: 40,
  scienceField: 56,
  searchNotificationContent: 184,
  searchPeriod: 181,
  searchResource: 180,
  settingsAccessLevels: 133,
  uploadFileExt: 60,
  uploadFileMime: 58,
  uploadItemType: 129,
  uploadType: 126,
  user: 202,
};

export enum addressTypeCls {
  birthAddress = '20:6',
  livingAddress = '20:2',
}

export enum contactTypeCls {
  site = '31:1',
  phone = '31:2',
  email = '31:3',
  messenger = '31:4',
  manager = '31:5',
  person = '31:6',
  socialNetwork = '31:7',
}

export const identitySystemCls = {
  authorMark: '38:57',
  bbk: '38:54',
  doi: '38:56',
  isbn: '38:51',
  issn: '38:52',
  orcid: '38:3',
  researcherId: '38:4',
  spinCode: '38:6',
  udk: '38:53',
};

export const identitySystemClsLocalization = {
  authorMark: '38:57',
  bbk: '38:54',
  data: 'data',
  doi: '38:56',
  isbn: '38:51',
  issn: '38:52',
  orcid: 'scientific.data.orcid',
  researcherId: 'scientific.data.researcherid',
  spinCode: 'scientific.data.spin',
  udk: '38:53',
};

export const uploadTypeCls = {
  package: `${cls.uploadType}:2`,
  single: `${cls.uploadType}:1`,
};

export const uploadItemTypeCls = {
  publication: `${cls.uploadItemType}:1`,
};

export const settingsAccessLevelsBinary = [
  {
    term: 'Вкл',
    uref: true,
  },
  {
    term: 'Выкл',
    uref: false,
  },
];
